import React from "react";

export const enquiryInputClassName =
  "w-full p-3 text-sm bg-bg-white text-text-obsidian border border-solid border-[rgba(0,0,0,0.1)] font-manrope transition-all duration-300 focus:outline-none focus:border-brand-yellow placeholder:text-text-slate/75";

export const enquirySubmitClassName =
  "w-full mt-2 p-3 bg-text-obsidian text-white border-none font-teko text-base uppercase tracking-wider cursor-pointer transition-all duration-300 hover:bg-brand-yellow hover:text-text-obsidian disabled:opacity-60 disabled:cursor-not-allowed";

interface EnquiryFormFieldsProps {
  name: string;
  email: string;
  phone: string;
  message: string;
  onNameChange: (value: string) => void;
  onEmailChange: (value: string) => void;
  onPhoneChange: (value: string) => void;
  onMessageChange: (value: string) => void;
  submitting: boolean;
  submitLabel?: string;
  messagePlaceholder?: string;
  extraFields?: React.ReactNode;
}

const EnquiryFormFields: React.FC<EnquiryFormFieldsProps> = ({
  name,
  email,
  phone,
  message,
  onNameChange,
  onEmailChange,
  onPhoneChange,
  onMessageChange,
  submitting,
  submitLabel = "Submit",
  messagePlaceholder = "Message / Requirements",
  extraFields,
}) => {
  return (
    <>
      {extraFields}
      <input
        type="text"
        className={enquiryInputClassName}
        placeholder="Full Name"
        value={name}
        onChange={(e) => onNameChange(e.target.value)}
        required
        disabled={submitting}
      />
      <input
        type="email"
        className={enquiryInputClassName}
        placeholder="Email Address"
        value={email}
        onChange={(e) => onEmailChange(e.target.value)}
        required
        disabled={submitting}
      />
      <input
        type="tel"
        className={enquiryInputClassName}
        placeholder="Phone Number"
        value={phone}
        onChange={(e) => onPhoneChange(e.target.value)}
        disabled={submitting}
      />
      <textarea
        className={enquiryInputClassName}
        rows={3}
        placeholder={messagePlaceholder}
        value={message}
        onChange={(e) => onMessageChange(e.target.value)}
        required
        disabled={submitting}
      />
      <button
        type="submit"
        className={enquirySubmitClassName}
        disabled={submitting}
      >
        {submitting ? "Sending…" : submitLabel}
      </button>
    </>
  );
};

export default EnquiryFormFields;
